import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Create Template</Typography>
      <p>Before you can issue any passes you must have a template.</p>

      <p>We have provided a selection of base-templates for you to choose from.</p>

      <p>Click on any template, review the full description. If it meets your needs,
        just choose a name and click the button. Smartix will create an editable duplicate
        of that template and place it in your template list.
      </p>

      <Typography variant='h5' className='pb-5 pt-10'>Custom Templates</Typography>
      <p>If you already have your own systems and forsee integrating Smartix API
        into your workflow then you will need to choose a Custom Template.
      </p>

      <p>With a Custom Template, you control the barcode and you provide your own
        scanning equipment that you integrate into your existing sytem.
      </p>

      <p>You have full flexibility in how you design your passes.</p>

      <Typography variant='h5' className='pb-5 pt-10'>Smartix managed Templates</Typography>
      <p>If you do not have your own system or scanning equipment then you will want to use
        our Free Smartix Scan app to validate the passes that you issue. You need to choose
        a Smartix Managed Template which are compatible with Smartix Scan
      </p>

      <p>With these template, Smartix controls the barcode content. It creates a barcode that
        Smartix Scan can read and identify your pass. All you havew to worry about it the
        pass design and individual content.
      </p>

      <p>Since Smartix wil be processing scans and acting upon them to potentially change
        the content of the pass (eg. Updating loyalty points), we have to limit your design
        choices to preserve the fields that Smartix us using.
      </p>

      <Typography variant='h5' className='pb-5 pt-10'>Specialist Templates</Typography>
      <p>
        Sometimes a Custom Template would work, but would mean considerable complication 
        aligning all the data when issueign passes. This is where Specialist Templates come in.</p>

      <p>Our first Specialist Templates are UK Rail tickets where Smartix automatically creates
        itinerary information keeping the pass creation as simple as possible.
      </p>

      <p>If you would like to use one of our specialist templates, or would like us to create
        a custom one for you, then please get on touch. We will be happy to assist.
      </p>


    </div>
  )
}

export default HelpText